import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";

const PartnersSection = () => {
  const { data: partners, isLoading } = useQuery({
    queryKey: ['partners'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('partners' as any)
        .select('name, slug, logo_url')
        .eq('is_active', true)
        .order('created_at', { ascending: true });
      
      if (error) throw error;
      return data;
    },
    staleTime: 1000 * 60 * 30, // 30 mins
  });

  if (isLoading) {
    return (
      <section className="py-12 border-b border-slate-100">
        <div className="container mx-auto px-6">
          <div className="flex justify-center gap-12 opacity-30">
            {[1, 2, 3].map(i => <Skeleton key={i} className="h-8 w-24" />)}
          </div>
        </div>
      </section>
    );
  }

  if (!partners || partners.length === 0) return null;

  // ניצור מערך מרובע כדי להבטיח שהלופ של האנימציה (Marquee) יהיה רציף וארוך מספיק גם במסכים רחבים
  const marqueePartners = [...partners, ...partners, ...partners, ...partners];

  return (
    <section className="py-12 border-b border-slate-100 overflow-hidden">
      <div className="container mx-auto text-center px-0 md:px-6">
        <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-8 px-6 md:px-0">
          פתרונות ומומחים לשדרוג המערכת
        </p>
        
        {/* Desktop: Static Centered Grid */}
        <div className="hidden md:flex flex-wrap items-center justify-center gap-16 px-6">
          {partners.map((partner: any) => (
            <Link 
              key={`desktop-${partner.slug}`} 
              to={`/partners/${partner.slug}`}
              className="group relative transition-transform duration-300 hover:scale-105"
            >
              <img 
                src={partner.logo_url} 
                alt={partner.name} 
                className="h-10 w-auto max-w-[160px] object-contain"
              />
            </Link>
          ))}
        </div>

        {/* Mobile: Smooth Animated Marquee (Timeline) */}
        <div className="md:hidden relative flex w-full">
          <div 
            className="flex items-center gap-12 w-max px-6 hover:[animation-play-state:paused] active:[animation-play-state:paused]"
            style={{ animation: 'marquee-rtl 35s linear infinite' }}
          >
            {marqueePartners.map((partner: any, idx: number) => (
              <Link 
                key={`mobile-${partner.slug}-${idx}`} 
                to={`/partners/${partner.slug}`}
                className="shrink-0 group transition-transform duration-300 hover:scale-105"
              >
                <img 
                  src={partner.logo_url} 
                  alt={partner.name} 
                  className="h-8 w-auto max-w-[120px] object-contain"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;